import React, { Fragment } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import LocationOnIcon from "@material-ui/icons/LocationOn";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import parse from "autosuggest-highlight/parse";
import throttle from "lodash/throttle";
import GpsFixedIcon from "@material-ui/icons/GpsFixed";
import InputAdornment from "@material-ui/core/InputAdornment";
import { useStyles } from "./classes";
import axios from "axios";
import { IconButton, TextField, Popper } from "@material-ui/core";
import DataLoadingFail from "../../components/errorPages/DataLodingFail";

function loadScript(src, position, id) {
  if (!position) {
    return;
  }

  const script = document.createElement("script");
  script.setAttribute("async", "");
  script.setAttribute("id", id);
  script.src = src;
  position.appendChild(script);
}

const autocompleteService = { current: null };

export default function GoogleMaps({
  setFieldValue,
  values,
  props,
  handleOpen,
}) {
  const getLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
      alert("Geolocation is not supported by this browser.");
    }
  };

  const setCoordinates = async (placeId) => {
    try {
      const { data } = await axios.post("/location/place", {
        placeId,
      });

      setFieldValue("coordinates.lat", data.lat);
      setFieldValue("coordinates.lng", data.lng);
    } catch (error) {
      // alert("Backend server error.");
      <DataLoadingFail />;
    }
  };

  const classes = useStyles();
  const [value, setValue] = React.useState({
    description: "",
  });
  const [inputValue, setInputValue] = React.useState("");

  const [options, setOptions] = React.useState([]);
  const loaded = React.useRef(false);
  const showPosition = async (position) => {
    try {
      const place = await axios.post("/location", {
        lat: position.coords.latitude,
        lng: position.coords.longitude,
      });

      if (place.data) {
        setValue({
          description: place.data,
        });
        setFieldValue("coordinates.lat", position.coords.latitude);
        setFieldValue("coordinates.lng", position.coords.longitude);
        setFieldValue("location", place.data);
      } else {
        // alert("Backend can't find your location.");
        handleOpen(true);
      }
    } catch (error) {
      // alert("Backend sever error!");
      handleOpen(true);
    }
  };

  if (typeof window !== "undefined" && !loaded.current) {
    if (!document.querySelector("#google-maps")) {
      loadScript(
        `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_PLACES_KEY}&libraries=places`,
        document.querySelector("head"),
        "google-maps"
      );
    }

    loaded.current = true;
  }

  const fetch = React.useMemo(
    () =>
      throttle((request, callback) => {
        autocompleteService.current.getPlacePredictions(request, callback);
      }, 200),
    []
  );

  React.useEffect(() => {
    let active = true;

    if (!autocompleteService.current && window.google) {
      autocompleteService.current = new window.google.maps.places.AutocompleteService();
    }
    if (!autocompleteService.current) {
      return undefined;
    }

    if (inputValue === "") {
      setOptions(value ? [value] : []);
      return undefined;
    }

    fetch({ input: inputValue }, (results) => {
      if (active) {
        let newOptions = [];

        if (value) {
          newOptions = [value];
        }

        if (results) {
          newOptions = [...newOptions, ...results];
        }

        setOptions(newOptions);
      }
    });

    return () => {
      active = false;
    };
  }, [value, inputValue, fetch]);

  const PopperMy = function (props) {
    return <Popper {...props} placement="none" />;
  };

  return (
    <Fragment>
      <Autocomplete
        PopperComponent={PopperMy}
        disabled={values.type === "restaurant"}
        size="small"
        id="google-map-demo"
        getOptionLabel={(option) =>
          typeof option === "string" ? option : option.description
        }
        filterOptions={(x) => x}
        options={options}
        autoComplete
        includeInputInList
        filterSelectedOptions
        defaultValue={{
          description: "Homagama",
        }}
        value={value}
        onChange={(event, newValue) => {
          if (newValue) {
            const { place_id } = newValue;
            setCoordinates(place_id);
            setOptions(newValue ? [newValue, ...options] : options);
            setValue(newValue);
            setFieldValue("location", newValue.description);
          } else {
            setValue(null);
            setFieldValue("coordinates.lat", null);
            setFieldValue("coordinates.lng", null);
          }
        }}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        renderInput={(params) => (
          <div>
            <TextField
              disabled={values.type === "restaurant"}
              {...params}
              className={
                values.type === "restaurant"
                  ? classes.borderDisabled
                  : classes.borderEnabled
              }
              defaultValue={{
                description: "Homagama",
              }}
              placeholder="Near Me.."
              InputLabelProps={{ shrink: false }}

              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <InputAdornment position="start">
                    <IconButton
                      onClick={() => getLocation()}
                      disabled={values.type === "restaurant"}
                    >
                      <GpsFixedIcon
                        className={
                          values.type === "restaurant"
                            ? classes.gpsIconDisabled
                            : classes.gpsIcon
                        }
                      />
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              fullWidth
            />
          </div>
        )}
        renderOption={(option) => {
          let parts = [];
          if (option.structured_formatting) {
            const matches =
              option.structured_formatting.main_text_matched_substrings;
            parts = parse(
              option.structured_formatting.main_text,
              matches.map((match) => [
                match.offset,
                match.offset + match.length,
              ])
            );
          }
          return (
            <Grid container alignItems="center">
              <Grid item>
                <LocationOnIcon className={classes.icon} />
              </Grid>
              <Grid item xs>
                {parts.map((part, index) => (
                  <span
                    key={index}
                    style={{ fontWeight: part.highlight ? 700 : 400 }}
                  >
                    {part.text}
                  </span>
                ))}

                <Typography variant="body2" color="textSecondary">
                  {option.structured_formatting &&
                    option.structured_formatting.secondary_text}
                </Typography>
              </Grid>
            </Grid>
          );
        }}
      />
    </Fragment>
  );
}
